import Entry from "./Entry";
import InputForm from "../InputForm/InputForm";
import TopNav from "../TopNav/TopNav";
import Display from "../Display/Display";
import {AlertBar} from "../AlertBar/AlertBar";

const Dependencies = (props) => {
    return (<Entry  TopNav = {TopNav} InputForm = {InputForm} Display = {Display} AlertBar={AlertBar} userData={props.userData} bearerToken={props.bearerToken} userIdentity={props.userIdentity}/>)
};
export default Dependencies;